import { useDispatch } from 'react-redux';

import { actions } from 'containers/SharedState/slice';
import { LearnMoreFieldType } from 'containers/SharedState/types';

export const useKnowledgeBase = () => {
  const dispatch = useDispatch();
  const setLearnMore = (value?: LearnMoreFieldType) => {
    dispatch(actions.updateLearnMore(value ?? undefined));
  };

  return { setLearnMore };
};
